// @flow
import popOverFactory from 'common/components/core/popover/popOverFactory';
import { Icon } from '@locus-taxy/neo-ui';

const NeoIconWithPopover = popOverFactory({
    Component: Icon
});

export default NeoIconWithPopover;
